<template>
  <el-row>
    <el-col :span="3" style="margin-top: 10px">
      <el-image :lazy='true'
      class="img"
      :src="logo"></el-image>
    </el-col>
    <el-col :span="3" style="margin-top: 26px">
      <el-button type="text" class="base-font" @click="emitPageNum(1)">正在学习</el-button>      
    </el-col>
    <el-col :span="3" style="margin-top: 26px">
      <el-button type="text" class="base-font" @click="emitPageNum(2)">我的课程</el-button>      
    </el-col>
    <el-col :span="3" style="margin-top: 26px">
      <el-button type="text" class="base-font" @click="emitPageNum(3)">单词本</el-button>      
    </el-col>
    <el-col :span="3" style="margin-top: 26px">
      <el-button type="text" class="base-font" @click="emitPageNum(4)">排行榜</el-button>      
    </el-col>
    <el-col :span="3" style="margin-top: 26px">
      <el-button type="text" class="base-font" @click="emitPageNum(5)">学习统计</el-button>
    </el-col>
    <el-col :span="3" style="margin-top: 26px">
      <el-button type="text" class="base-font" @click="emitPageNum(6)">专项练习</el-button>
    </el-col>
    <el-col :span="2" :offset="1" style="margin-top: 30px" v-if="info == null">
      <el-button round style="font-size: 20px;color: #fff;background-color: #ffffff00;" @click="toLogin">登录</el-button>
    </el-col>
    <el-col :span="2" :offset="1" class="name-area" style="margin-top: 30px" v-else>
      <el-dropdown>
        <span class="el-dropdown-link">
          <p style="font-size: 20px;margin: 5px 0 0 0;color: #fff">{{info.nickname}}</p>
        </span>
        <el-dropdown-menu slot="dropdown" style="width: 70px">
          <el-dropdown-item style="margin: auto">
            <span @click="logout()">登出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters,mapMutations } from 'vuex'
import Logo from "../../../assets/awesome-img.png";

export default {
  data: ()=>{
    return {
      logo: Logo,
    }
  },
  computed: {
    ...mapGetters({
      info: 'getInfo',
    })
  },
  methods: {
    ...mapMutations([
      'deleteInfo'
    ]),
    emitPageNum(i) {
      this.$emit('click-page',i)
    },
    toLogin() {
      this.$router.push('login')
    },
    logout() {
      this.deleteInfo();
      this.toLogin();
    }
  }

}
</script>

<style scoped>
.el-dropdown-link {
  cursor: pointer;
}
.el-icon-arrow-down {
  font-size: 20px;
}
.el-button:focus, .el-button:hover {
  color: #ffffff;
  background-color: #ffffff00;
}
.base-font{
  font-size: 25px;
  color: #fff;
}
.name-area{
  color: #ffffff;
  border: 2px;
  border-color: #ffffff
}
.img{
  width: 90%;
  height: 50%;
  margin: 5% 0 0 10%;
}
@media screen and (max-width: 1400px){
  .img{
    width: 80%;
    height: 50%;
    margin: 22% 0 0 10%;
  }
}
</style>
